// Schrift "Ubuntu" (Tanzschulmanager-Design), selbst gehostet auf webapp.tanzschulmanager.net.
// @font-face wirkt nicht innerhalb des Shadow DOM, deshalb wird die Deklaration einmal in den Kopf der Website eingefuegt.
const FONT_BASE = "https://webapp.tanzschulmanager.net/default/fonts/";
const STYLE_ID = "tsm-webcomponent-fonts";

const FACES: Array<{ weight: number; subset: string; range: string }> = [
  { weight: 400, subset: "latin-ext", range: "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF" },
  { weight: 400, subset: "latin", range: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD" },
  { weight: 500, subset: "latin-ext", range: "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF" },
  { weight: 500, subset: "latin", range: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD" },
  { weight: 700, subset: "latin-ext", range: "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF" },
  { weight: 700, subset: "latin", range: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD" },
];

export function ensureFonts(): void {
  if (typeof document === "undefined" || document.getElementById(STYLE_ID)) {
    return;
  }
  const css = FACES.map(
    (f) =>
      `@font-face{font-family:'Ubuntu';font-style:normal;font-weight:${f.weight};font-display:swap;` +
      `src:url(${FONT_BASE}ubuntu-${f.weight}-${f.subset}.woff2) format('woff2');unicode-range:${f.range};}`,
  ).join("\n");
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = css;
  document.head.appendChild(style);
}
